import React from 'react';
import styled from 'styled-components';
import { Inbox } from '@bynder/notifications-frontend';
import { LiWithFocusHighlight } from '../CommonStyles';

export function HybridNotificationCenter() {
	return (
		<LiWithFocusHighlight className="notifications-nav">
			<NotificationBadge>
				<Inbox />
			</NotificationBadge>
		</LiWithFocusHighlight>
	);
}

export const NotificationBadge = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
`;
